module.exports = __webpack_public_path__ + "img/shape-metal_ac-mobile-gold@2x.aefc9e2d.png";